import { ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, Renderer2 } from '@angular/core'
import { ReplaySubject, Subject } from 'rxjs'
import { switchMap, takeUntil, tap } from 'rxjs/operators'
import { ImageLoaderService } from '@adex/shared/components/image/image-loader.service'


@Component({
  selector: 'adex-image',
  template: ``,
  styleUrls: [ './image.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'adex-image' }
})
export class ImageComponent implements OnDestroy {
  private currentSrcClassName: string
  private readonly destroy$: Subject<void> = new Subject()
  private readonly src$: ReplaySubject<string> = new ReplaySubject(1)
  private readonly image$ = this.src$.pipe(
    switchMap(src => this.loader.load<string>(src).pipe(
      tap(img => this.setImage(img)),
      tap(() => this.updateClass(src))
    )),
    takeUntil(this.destroy$)
  )

  constructor(
    private readonly loader: ImageLoaderService,
    private readonly renderer: Renderer2,
    private readonly el: ElementRef
  ) {
    this.image$.subscribe()
  }

  @Input()
  set src(value: string) {
    if (!value) return
    this.src$.next(value)
  }

  public ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  private setImage(img: string): void {
    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', img)
  }

  private updateClass(value: string) {
    this.renderer.removeClass(this.el.nativeElement, this.currentSrcClassName)
    this.currentSrcClassName = value
    this.renderer.addClass(this.el.nativeElement, this.currentSrcClassName)
  }

}
